import { Component, OnInit } from '@angular/core';
import { forwardRef } from '@angular/core';
import { Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NG_VALIDATORS } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';
import { ControlValueAccessor } from '@angular/forms';
import { Validator } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { UtilService } from '../../../../../shared-services/util.service';

@Component({
    selector: 'app-user-password',
    templateUrl: './user-password.component.html',
    styleUrls: ['./user-password.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UserPasswordComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => UserPasswordComponent),
            multi: true
        }
    ]
})

export class UserPasswordComponent implements OnInit, ControlValueAccessor, Validator {
    @Input()
    readonlyOnValid: boolean;

    @Input()
    columns: number = 2;

    public changePasswordForm: FormGroup;
    readonlyState: any;

    constructor(private utilsService: UtilService, private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.changePasswordForm = this.formBuilder.group({
          oldPassword: ['', Validators.required],
          newPassword: [null, Validators.compose([
            // 1. Password Field is Required
            Validators.required,
            // 2. check whether the entered password has a number
            this.utilsService.patternValidator(/\d/, {hasNumber: true}),
            // 3. check whether the entered password has upper case letter
            this.utilsService.patternValidator(/[A-Z]/, {hasCapitalCase: true}),
            // 4. check whether the entered password has a lower-case letter
            this.utilsService.patternValidator(/[a-z]/, {hasSmallCase: true}),
            // 6. Has a minimum length of 6 characters
            Validators.minLength(6),
            // 7. Has a minimum length of 13 characters
            Validators.maxLength(13),
            // 4. check whether the entered password has a lower-case letter
            this.utilsService.patternValidator(/^\S*$/, {hasSpace: true}),
          ])],
          validatePassword: ['', Validators.required]
        });

        this.readonlyState = {
            oldPassword: this.readonlyOnValid && this.changePasswordForm.controls.oldPassword.valid,
            newPassword: this.readonlyOnValid && this.changePasswordForm.controls.newPassword.valid,
            validatePassword: this.readonlyOnValid && this.changePasswordForm.controls.validatePassword.valid
        }

        this.changePasswordForm.controls.oldPassword.patchValue("************");
    }

    public onTouched: () => void = () => {
    };

    writeValue(val: any): void {
        val && this.changePasswordForm.setValue(val, {emitEvent: false});
    }

    registerOnChange(fn: any): void {
        this.changePasswordForm.valueChanges
            .subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        isDisabled ? this.changePasswordForm.disable() : this.changePasswordForm.enable();
    }

    validate(c: AbstractControl): ValidationErrors | null {
        return this.changePasswordForm.valid ? null : {invalidForm: {valid: false, message: "basicInfoForm fields are invalid"}};
    }

}
